<template>
  <div>
    <section class="xs-banner service-banner-2 contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 col-md-6 align-self-center">
            <div class="xs-banner-content">
              <div class="xs-banner-group">
                <h2 class="banner-title wow fadeInLeft" data-wow-duration="1s">DOMAIN NAMES</h2>
                <p class="wow fadeInLeft" data-wow-duration="1.5s">Share processes and data securely on a need to know
                  basis without the need for reconciliation it combines a permissione.</p></div>
            </div>
          </div>
          <div class="col-lg-5 col-md-6 align-self-center">
            <div class="inner-welcome-image-group wow fadeIn">
              <img src="../assets/images/domain-bg.png" data-parallax='{"y": 150}'
                   alt="hosting image">
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-1318" class="full-width-content post-1318 page type-page status-publish hentry">
          <div data-elementor-type="wp-post" data-elementor-id="1318" class="elementor elementor-1318"
               data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <div
                  class="elementor-section elementor-top-section elementor-element elementor-element-9fe8d9f elementor-section-stretched elementor-section-full_width domain-search elementor-section-height-default elementor-section-height-default"
                  data-id="9fe8d9f" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;stretch_section&quot;:&quot;section-stretched&quot;}"
                  style="width: 1903px; left: -396.5px;">
                  <div class="elementor-container elementor-column-gap-narrow">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-509625b"
                        data-id="509625b" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-998927e"
                        data-id="998927e" data-element_type="column"
                        data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-f15e117 elementor-widget elementor-widget-xs-domain-checker"
                              data-id="f15e117" data-element_type="widget" data-widget_type="xs-domain-checker.default">
                              <div class="elementor-widget-container">
                                <div id="wdc-domain-form" class="wdc-form " data-wdc-style="1">
                                  <div id="wdc-style">
                                    <form method="post" action="" id="form" class="pure-form" data-wdc-style="1">

                                      <div class="input-group large" style="max-width:900px;">
                                        <input type="text" class="form-control" autocomplete="off" id="Search"
                                               name="domain" placeholder="domain.com" autocorrect="off">
                                        <span class="input-group-btn">
                        <button type="submit" id="Submit" class="btn btn-default btn-info">Search</button>
                        </span>
                                      </div>

                                      <div id="loading"><img
                                        src="../assets/images/load.gif"
                                        alt="loading" draggable="false"></div>
                                    </form>
                                    <div style="max-width:900px;">
                                      <div id="results" class="result large">
                                        <div class="callout callout-warning alert-warning clearfix req-domain-text">
                                          <div class="col-xs-10" style="padding-left:1px;text-align:left;"><i
                                            class="glyphicon glyphicon-remove" style="margin-right:10px;"></i> Please
                                            enter your domain.
                                          </div>
                                        </div>
                                        <div class="callout callout-warning alert-warning clearfix recaptcha-text">
                                          <div class="col-xs-10" style="padding-left:1px;text-align:left;"><i
                                            class="glyphicon glyphicon-remove" style="margin-right:10px;"></i> Please
                                            verify that you are not a robot.
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                                <ul class="xs-domain-info">
                                  <li>
                                    <img src="../assets/images/com.png" alt="com"
                                         draggable="false">
                                    <strong>$9.95</strong>
                                  </li>


                                  <li>
                                    <img src="../assets/images/co.png" alt="co"
                                         draggable="false">
                                    <strong>$7.95</strong>
                                  </li>


                                  <li>
                                    <img src="../assets/images/info.png" alt="info"
                                         draggable="false">
                                    <strong>$2.95</strong>
                                  </li>


                                  <li>
                                    <img src="../assets/images/net.png" alt="net"
                                         draggable="false">
                                    <strong>$5.95</strong>
                                  </li>

                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-38e67c0"
                        data-id="38e67c0" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-e6e1ffa elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="e6e1ffa" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-00d4d8f"
                        data-id="00d4d8f" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-bc2e26c"
                        data-id="bc2e26c" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-23903ac elementor-widget elementor-widget-xs-heading"
                              data-id="23903ac" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Best Hosting</h3>
                                  <h2 class="heading-title">Why <span>CHOOSE US</span></h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-bab2855"
                        data-id="bab2855" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-1137799 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="1137799" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-7d730a1 animated-slow animated fadeInUp"
                        data-id="7d730a1" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:0.7}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-35c90e9 elementor-widget elementor-widget-xs-image-box"
                              data-id="35c90e9" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-1.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">99.9% Uptime Guarantee</h4>
                                  <p>Share processes and data secure
                                    lona need to know basis</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-5148a5d animated-slow animated fadeInUp"
                        data-id="5148a5d" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:1.5}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-00f0aeb elementor-widget elementor-widget-xs-image-box"
                              data-id="00f0aeb" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-2.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Safe and Secured</h4>
                                  <p>Our team assured your web site is always safe and secure</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-85cb4e6 animated-slow animated fadeInUp"
                        data-id="85cb4e6" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:2}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-2c27b4b elementor-widget elementor-widget-xs-image-box"
                              data-id="2c27b4b" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-3.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Our Dedicated Support</h4>
                                  <p>We finally found a host that truly understood the unique</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-10f8457 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="10f8457" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-01e7e7f"
                        data-id="01e7e7f" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-171779b elementor-widget elementor-widget-xs-domain-pricing"
                              data-id="171779b" data-element_type="widget" data-widget_type="xs-domain-pricing.default">
                              <div class="elementor-widget-container">
                                <div class="table-responsive-md wow fadeIn animated"
                                     style="visibility: visible; animation-name: fadeIn;">
                                  <table class="table xs-table">
                                    <thead class="domain-pricing-header">
                                    <tr>
                                      <th scope="col">Name</th>
                                      <th scope="col">Register</th>
                                      <th scope="col">Transfer</th>
                                      <th scope="col">Renew</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>

                                      <th scope="row">
                                        <img src="../assets/images/com.png"
                                             alt="domain name com icon" draggable="false">
                                      </th>

                                      <td>$19.95
                                        <del>$23.90</del>
                                      </td>
                                      <td>$19.95</td>
                                      <td>$19.95</td>
                                    </tr>

                                    <tr>

                                      <th scope="row">
                                        <img src="../assets/images/me.png"
                                             alt="domain name com icon" draggable="false">
                                      </th>

                                      <td>$16.95</td>
                                      <td>$16.95</td>
                                      <td>$16.95</td>
                                    </tr>

                                    <tr>

                                      <th scope="row">
                                        <img src="../assets/images/biz.png"
                                             alt="domain name com icon" draggable="false">
                                      </th>

                                      <td>$09.95</td>
                                      <td>$09.95</td>
                                      <td>$09.95</td>
                                    </tr>

                                    <tr>

                                      <th scope="row">
                                        <img src="../assets/images/co.png"
                                             alt="domain name com icon" draggable="false">
                                      </th>

                                      <td>$15.95</td>
                                      <td>$15.95</td>
                                      <td>$15.95</td>
                                    </tr>

                                    <tr>

                                      <th scope="row">
                                        <img src="../assets/images/net.png"
                                             alt="domain name com icon" draggable="false">
                                      </th>

                                      <td>$19.95</td>
                                      <td>$19.95</td>
                                      <td>$19.95</td>
                                    </tr>

                                    <tr>

                                      <th scope="row">
                                        <img src="../assets/images/info.png"
                                             alt="domain name com icon" draggable="false">
                                      </th>

                                      <td>$14.95
                                        <del> $18.95</del>
                                      </td>
                                      <td>$14.95</td>
                                      <td>$14.95</td>
                                    </tr>

                                    <tr>

                                      <th scope="row">
                                        <img src="../assets/images/store.png"
                                             alt="domain name com icon" draggable="false">
                                      </th>

                                      <td>$16.95</td>
                                      <td>$16.95</td>
                                      <td>$16.95</td>
                                    </tr>

                                    <tr>

                                      <th scope="row">
                                        <img src="../assets/images/mobi.png"
                                             alt="domain name com icon" draggable="false">
                                      </th>

                                      <td>$18.95</td>
                                      <td>$18.95</td>
                                      <td>$18.95</td>
                                    </tr>


                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-82c71dd elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="82c71dd" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3d563d8"
                        data-id="3d563d8" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-8834526 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="8834526" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-cd27aaf"
                                    data-id="cd27aaf" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-02af0c7"
                                    data-id="02af0c7" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-d4a706c elementor-widget elementor-widget-xs-heading"
                                          data-id="d4a706c" data-element_type="widget"
                                          data-widget_type="xs-heading.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-heading">
                                              <h3 class="heading-sub-title">We Offer</h3>
                                              <h2 class="heading-title">FEATURES INCLUDED</h2>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-23eb552"
                                    data-id="23eb552" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-62ba27d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="62ba27d" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-ab08309"
                                    data-id="ab08309" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-e8466b4 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="e8466b4" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="49" height="68"
                                                                                           src="../assets/images/included-feature-1.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">No Multi Tenancy</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-278ea5d elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="278ea5d" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="52" height="67"
                                                                                           src="../assets/images/included-feature-2.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">LiteSpeed Web Server</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-738bee7 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="738bee7" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="50" height="45"
                                                                                           src="../assets/images/included-feature-3.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> cPanel Hosting Control</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-34bd5c1"
                                    data-id="34bd5c1" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-eaffdc8 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="eaffdc8" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="49" height="41"
                                                                                           src="../assets/images/included-feature-4.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">PHP Selector</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-5f06385 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="5f06385" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="52" height="53"
                                                                                           src="../assets/images/included-feature-5.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> LiteSpeed Web Server</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-2208ec2 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="2208ec2" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="47" height="55"
                                                                                           src="../assets/images/included-feature-6.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> Patchman Kiler</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-288e887 elementor-section-height-min-height elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
                  data-id="288e887" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6e6b5fc"
                        data-id="6e6b5fc" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-f8bda8e elementor-widget elementor-widget-xs-testimonial"
                              data-id="f8bda8e" data-element_type="widget" data-widget_type="xs-testimonial.default">
                              <div class="elementor-widget-container">
                                <div class="xs-testimonial-slider owl-carousel owl-loaded owl-drag">

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transition: all 0s ease 0s; width: 3834px; transform: translate3d(-766px, 0px, 0px);">
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-4-55x55.jpg"
                                                  alt="avatar-4" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active center" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-3-55x55.png"
                                                  alt="avatar-3" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-4-55x55.jpg"
                                                  alt="avatar-4" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-3-55x55.png"
                                                  alt="avatar-3" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-a03379d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="a03379d" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-155ab83"
                        data-id="155ab83" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-f5b1230 elementor-widget elementor-widget-xs-partner"
                              data-id="f5b1230" data-element_type="widget" data-widget_type="xs-partner.default">
                              <div class="elementor-widget-container">
                                <div class="xs-client-slider owl-carousel owl-loaded owl-drag">


                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transform: translate3d(-1120px, 0px, 0px); transition: all 0s ease 0s; width: 3360px;">
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-2cbeb40 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="2cbeb40" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-518fa49"
                        data-id="518fa49" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-37056d7 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="37056d7" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="122" height="138"
                                           src="../assets/images/sheild-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Days money back guarantee</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-3b89aab"
                        data-id="3b89aab" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-c075ff8 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="c075ff8" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="129" height="138"
                                           src="../assets/images/cloud-lock-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Build and protect your brand</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-ef8bd16 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="ef8bd16" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1b3f88c"
                        data-id="1b3f88c" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-0b0931b elementor-widget elementor-widget-spacer"
                              data-id="0b0931b" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'DomainName'
}
</script>

<style scoped>
.elementor-1318 .elementor-element.elementor-element-9fe8d9f {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  margin-top: -124px;
  margin-bottom: 0px;
  z-index: 8;
}

.elementor-1318 .elementor-element.elementor-element-9fe8d9f > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-bc-flex-widget .elementor-1318 .elementor-element.elementor-element-509625b.elementor-column .elementor-column-wrap {
  align-items: center;
}

.elementor-1318 .elementor-element.elementor-element-509625b.elementor-column.elementor-element[data-element_type="column"] > .elementor-column-wrap.elementor-element-populated > .elementor-widget-wrap {
  align-content: center;
  align-items: center;
}

.elementor-1318 .elementor-element.elementor-element-509625b > .elementor-element-populated {
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.07);
}

.elementor-bc-flex-widget .elementor-1318 .elementor-element.elementor-element-998927e.elementor-column .elementor-column-wrap {
  align-items: center;
}

.elementor-1318 .elementor-element.elementor-element-998927e.elementor-column.elementor-element[data-element_type="column"] > .elementor-column-wrap.elementor-element-populated > .elementor-widget-wrap {
  align-content: center;
  align-items: center;
}

.elementor-1318 .elementor-element.elementor-element-998927e:not(.elementor-motion-effects-element-type-background) > .elementor-column-wrap, .elementor-1318 .elementor-element.elementor-element-998927e > .elementor-column-wrap > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-color: #ffffff;
}

.elementor-1318 .elementor-element.elementor-element-998927e > .elementor-element-populated {
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.07);
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  padding: 50px 50px 50px 50px;
}

.elementor-1318 .elementor-element.elementor-element-998927e > .elementor-element-populated > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-bc-flex-widget .elementor-1318 .elementor-element.elementor-element-38e67c0.elementor-column .elementor-column-wrap {
  align-items: center;
}

.elementor-1318 .elementor-element.elementor-element-38e67c0.elementor-column.elementor-element[data-element_type="column"] > .elementor-column-wrap.elementor-element-populated > .elementor-widget-wrap {
  align-content: center;
  align-items: center;
}

.elementor-1318 .elementor-element.elementor-element-38e67c0 > .elementor-element-populated {
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.07);
}

.elementor-1318 .elementor-element.elementor-element-e6e1ffa {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  margin-top: 0px;
  margin-bottom: 0px;
  padding: 90px 0px 0px 0px;
}

.elementor-1318 .elementor-element.elementor-element-e6e1ffa > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-1137799 {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 0px 0px 85px 0px;
}

.elementor-1318 .elementor-element.elementor-element-82c71dd:not(.elementor-motion-effects-element-type-background), .elementor-1318 .elementor-element.elementor-element-82c71dd > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-color: transparent;
  background-image: linear-gradient(130deg, #15095e 49%, #1045db 84%);
}

.elementor-1318 .elementor-element.elementor-element-82c71dd {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  margin-top: 100px;
  margin-bottom: 0px;
  padding: 80px 10px 10px 10px;
}

.elementor-1318 .elementor-element.elementor-element-82c71dd > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-d4a706c .xs-heading .heading-title {
  color: #ffffff;
}

.elementor-1318 .elementor-element.elementor-element-d4a706c .xs-heading .heading-sub-title {
  color: #ffffff;
}

.elementor-1318 .elementor-element.elementor-element-ab08309 > .elementor-element-populated {
  padding: 10px 15px 10px 15px;
}

.elementor-1318 .elementor-element.elementor-element-e8466b4.elementor-position-right .elementor-image-box-img {
  margin-left: 25px;
}

.elementor-1318 .elementor-element.elementor-element-e8466b4.elementor-position-left .elementor-image-box-img {
  margin-right: 25px;
}

.elementor-1318 .elementor-element.elementor-element-e8466b4.elementor-position-top .elementor-image-box-img {
  margin-bottom: 25px;
}

.elementor-1318 .elementor-element.elementor-element-e8466b4 .elementor-image-box-wrapper .elementor-image-box-img {
  width: 10%;
}

.elementor-1318 .elementor-element.elementor-element-e8466b4 .elementor-image-box-img img {
  transition-duration: 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-e8466b4 .elementor-image-box-title {
  margin-bottom: 15px;
  color: #ffffff;
  font-family: "Rubik", Sans-serif;
  font-size: 1.17647rem;
  font-weight: 500;
}

.elementor-1318 .elementor-element.elementor-element-e8466b4 .elementor-image-box-description {
  color: #ffffff;
  font-family: "Karla", Sans-serif;
  font-weight: 400;
  font-style: normal;
}

.elementor-1318 .elementor-element.elementor-element-e8466b4 > .elementor-widget-container {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 57px 0px;
}

.elementor-1318 .elementor-element.elementor-element-278ea5d.elementor-position-right .elementor-image-box-img {
  margin-left: 25px;
}

.elementor-1318 .elementor-element.elementor-element-278ea5d.elementor-position-left .elementor-image-box-img {
  margin-right: 25px;
}

.elementor-1318 .elementor-element.elementor-element-278ea5d.elementor-position-top .elementor-image-box-img {
  margin-bottom: 25px;
}

.elementor-1318 .elementor-element.elementor-element-278ea5d .elementor-image-box-wrapper .elementor-image-box-img {
  width: 10%;
}

.elementor-1318 .elementor-element.elementor-element-278ea5d .elementor-image-box-img img {
  transition-duration: 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-278ea5d .elementor-image-box-title {
  margin-bottom: 15px;
  color: #ffffff;
  font-family: "Rubik", Sans-serif;
  font-size: 1.17647rem;
  font-weight: 500;
}

.elementor-1318 .elementor-element.elementor-element-278ea5d .elementor-image-box-description {
  color: #ffffff;
  font-family: "Karla", Sans-serif;
}

.elementor-1318 .elementor-element.elementor-element-278ea5d > .elementor-widget-container {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 57px 0px;
}

.elementor-1318 .elementor-element.elementor-element-738bee7.elementor-position-right .elementor-image-box-img {
  margin-left: 25px;
}

.elementor-1318 .elementor-element.elementor-element-738bee7.elementor-position-left .elementor-image-box-img {
  margin-right: 25px;
}

.elementor-1318 .elementor-element.elementor-element-738bee7.elementor-position-top .elementor-image-box-img {
  margin-bottom: 25px;
}

.elementor-1318 .elementor-element.elementor-element-738bee7 .elementor-image-box-wrapper .elementor-image-box-img {
  width: 10%;
}

.elementor-1318 .elementor-element.elementor-element-738bee7 .elementor-image-box-img img {
  transition-duration: 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-738bee7 .elementor-image-box-title {
  margin-bottom: 15px;
  color: #ffffff;
  font-family: "Rubik", Sans-serif;
  font-size: 1.17647rem;
  font-weight: 500;
}

.elementor-1318 .elementor-element.elementor-element-738bee7 .elementor-image-box-description {
  color: #ffffff;
  font-family: "Karla", Sans-serif;
}

.elementor-1318 .elementor-element.elementor-element-738bee7 > .elementor-widget-container {
  padding: 0px 0px 57px 0px;
}

.elementor-1318 .elementor-element.elementor-element-34bd5c1 > .elementor-element-populated {
  padding: 10px 15px 10px 15px;
}

.elementor-1318 .elementor-element.elementor-element-eaffdc8.elementor-position-right .elementor-image-box-img {
  margin-left: 25px;
}

.elementor-1318 .elementor-element.elementor-element-eaffdc8.elementor-position-left .elementor-image-box-img {
  margin-right: 25px;
}

.elementor-1318 .elementor-element.elementor-element-eaffdc8.elementor-position-top .elementor-image-box-img {
  margin-bottom: 25px;
}

.elementor-1318 .elementor-element.elementor-element-eaffdc8 .elementor-image-box-wrapper .elementor-image-box-img {
  width: 10%;
}

.elementor-1318 .elementor-element.elementor-element-eaffdc8 .elementor-image-box-img img {
  transition-duration: 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-eaffdc8 .elementor-image-box-title {
  margin-bottom: 15px;
  color: #ffffff;
  font-family: "Rubik", Sans-serif;
  font-size: 1.17647rem;
  font-weight: 500;
}

.elementor-1318 .elementor-element.elementor-element-eaffdc8 .elementor-image-box-description {
  color: #ffffff;
  font-family: "Karla", Sans-serif;
  font-weight: 400;
  font-style: normal;
}

.elementor-1318 .elementor-element.elementor-element-eaffdc8 > .elementor-widget-container {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 57px 0px;
}

.elementor-1318 .elementor-element.elementor-element-5f06385.elementor-position-right .elementor-image-box-img {
  margin-left: 25px;
}

.elementor-1318 .elementor-element.elementor-element-5f06385.elementor-position-left .elementor-image-box-img {
  margin-right: 25px;
}

.elementor-1318 .elementor-element.elementor-element-5f06385.elementor-position-top .elementor-image-box-img {
  margin-bottom: 25px;
}

.elementor-1318 .elementor-element.elementor-element-5f06385 .elementor-image-box-wrapper .elementor-image-box-img {
  width: 10%;
}

.elementor-1318 .elementor-element.elementor-element-5f06385 .elementor-image-box-img img {
  transition-duration: 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-5f06385 .elementor-image-box-title {
  margin-bottom: 15px;
  color: #ffffff;
  font-family: "Rubik", Sans-serif;
  font-size: 1.17647rem;
  font-weight: 500;
}

.elementor-1318 .elementor-element.elementor-element-5f06385 .elementor-image-box-description {
  color: #ffffff;
  font-family: "Karla", Sans-serif;
  font-weight: 400;
  font-style: normal;
}

.elementor-1318 .elementor-element.elementor-element-5f06385 > .elementor-widget-container {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 57px 0px;
}

.elementor-1318 .elementor-element.elementor-element-2208ec2.elementor-position-right .elementor-image-box-img {
  margin-left: 25px;
}

.elementor-1318 .elementor-element.elementor-element-2208ec2.elementor-position-left .elementor-image-box-img {
  margin-right: 25px;
}

.elementor-1318 .elementor-element.elementor-element-2208ec2.elementor-position-top .elementor-image-box-img {
  margin-bottom: 25px;
}

.elementor-1318 .elementor-element.elementor-element-2208ec2 .elementor-image-box-wrapper .elementor-image-box-img {
  width: 10%;
}

.elementor-1318 .elementor-element.elementor-element-2208ec2 .elementor-image-box-img img {
  transition-duration: 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-2208ec2 .elementor-image-box-title {
  margin-bottom: 15px;
  color: #ffffff;
  font-family: "Rubik", Sans-serif;
  font-size: 1.17647rem;
  font-weight: 500;
}

.elementor-1318 .elementor-element.elementor-element-2208ec2 .elementor-image-box-description {
  color: #ffffff;
  font-family: "Karla", Sans-serif;
  font-weight: 400;
  font-style: normal;
}

.elementor-1318 .elementor-element.elementor-element-2208ec2 > .elementor-widget-container {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 57px 0px;
}

.elementor-1318 .elementor-element.elementor-element-288e887 > .elementor-container {
  min-height: 500px;
}

.elementor-1318 .elementor-element.elementor-element-288e887 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-288e887 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-f8bda8e .xs-testimonial-slider .owl-item .xs-testimonial-item::before, .xs-testimonial-slider .owl-item .xs-testimonial-item::after, .xs-testimonial-slider .owl-item .xs-testimonial-item {
  background-color: transparent;
  background-image: linear-gradient(180deg, #13279d 0%, #1045db 100%);
}

.elementor-1318 .elementor-element.elementor-element-f8bda8e .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item, .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item::before, .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item::after {
  background-color: #1633ff;
}

.elementor-1318 .elementor-element.elementor-element-f8bda8e .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item {
  opacity: 0.5;
}

.elementor-1318 .elementor-element.elementor-element-f8bda8e .commentor-bio .commentor-title {
  color: #ffffff;
}

.elementor-1318 .elementor-element.elementor-element-f8bda8e .xs-testimonial-slider .owl-item.center .testimonial-content .commentor-info {
  color: #ffffff;
}

.elementor-1318 .elementor-element.elementor-element-f8bda8e .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item p.commentor-info {
  color: #ffffff;
}

.elementor-1318 .elementor-element.elementor-element-f8bda8e .testimonial-content > p {
  color: #ffffff;
}

.elementor-1318 .elementor-element.elementor-element-f8bda8e .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item p {
  color: #ffffff;
}

.elementor-1318 .elementor-element.elementor-element-a03379d {
  margin-top: -100px;
  margin-bottom: 0px;
}

.elementor-1318 .elementor-element.elementor-element-2cbeb40 {
  margin-top: 80px;
  margin-bottom: -110px;
}

.elementor-1318 .elementor-element.elementor-element-37056d7 .xs-feature-group {
  background-color: #ffffff;
}

.elementor-1318 .elementor-element.elementor-element-37056d7 .xs-feature-group .xs-title {
  color: #1e1e1e;
}

.elementor-1318 .elementor-element.elementor-element-37056d7 .xs-feature-group p {
  color: #70799f;
}

.elementor-1318 .elementor-element.elementor-element-37056d7 .btn-secondary {
  color: #ffffff;
  background-color: #1868dd;
}

.elementor-1318 .elementor-element.elementor-element-37056d7 {
  z-index: 2;
}

.elementor-1318 .elementor-element.elementor-element-37056d7 > .elementor-widget-container {
  box-shadow: 0px -10px 25px 0px rgba(0, 0, 0, 0.04);
}

.elementor-1318 .elementor-element.elementor-element-c075ff8 .xs-feature-group {
  background-color: #ffffff;
}

.elementor-1318 .elementor-element.elementor-element-c075ff8 .xs-feature-group .xs-title {
  color: #1e1e1e;
}

.elementor-1318 .elementor-element.elementor-element-c075ff8 .xs-feature-group p {
  color: #70799f;
}

.elementor-1318 .elementor-element.elementor-element-c075ff8 .btn-secondary {
  color: #ffffff;
  background-color: #1868dd;
}

.elementor-1318 .elementor-element.elementor-element-c075ff8 {
  z-index: 2;
}

.elementor-1318 .elementor-element.elementor-element-c075ff8 > .elementor-widget-container {
  box-shadow: 0px -10px 25px 0px rgba(0, 0, 0, 0.04);
}

.elementor-1318 .elementor-element.elementor-element-ef8bd16:not(.elementor-motion-effects-element-type-background), .elementor-1318 .elementor-element.elementor-element-ef8bd16 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-color: #113072;
}

.elementor-1318 .elementor-element.elementor-element-ef8bd16 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-ef8bd16 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-1318 .elementor-element.elementor-element-0b0931b .elementor-spacer-inner {
  height: 80px;
}

@media (max-width: 767px) {
  .elementor-1318 .elementor-element.elementor-element-509625b {
    width: 3%;
  }

  .elementor-1318 .elementor-element.elementor-element-998927e {
    width: 94%;
  }

  .elementor-1318 .elementor-element.elementor-element-38e67c0 {
    width: 5%;
  }

  .elementor-1318 .elementor-element.elementor-element-e8466b4 .elementor-image-box-img {
    margin-bottom: 25px;
  }

  .elementor-1318 .elementor-element.elementor-element-278ea5d .elementor-image-box-img {
    margin-bottom: 25px;
  }

  .elementor-1318 .elementor-element.elementor-element-738bee7 .elementor-image-box-img {
    margin-bottom: 25px;
  }

  .elementor-1318 .elementor-element.elementor-element-eaffdc8 .elementor-image-box-img {
    margin-bottom: 25px;
  }

  .elementor-1318 .elementor-element.elementor-element-5f06385 .elementor-image-box-img {
    margin-bottom: 25px;
  }

  .elementor-1318 .elementor-element.elementor-element-2208ec2 .elementor-image-box-img {
    margin-bottom: 25px;
  }
}

@media (min-width: 768px) {
  .elementor-1318 .elementor-element.elementor-element-509625b {
    width: 7%;
  }

  .elementor-1318 .elementor-element.elementor-element-998927e {
    width: 85.333%;
  }

  .elementor-1318 .elementor-element.elementor-element-38e67c0 {
    width: 7%;
  }

  .elementor-1318 .elementor-element.elementor-element-00d4d8f {
    width: 16%;
  }

  .elementor-1318 .elementor-element.elementor-element-bc2e26c {
    width: 67.333%;
  }

  .elementor-1318 .elementor-element.elementor-element-bab2855 {
    width: 16%;
  }

  .elementor-1318 .elementor-element.elementor-element-cd27aaf {
    width: 25%;
  }

  .elementor-1318 .elementor-element.elementor-element-02af0c7 {
    width: 49.664%;
  }

  .elementor-1318 .elementor-element.elementor-element-23eb552 {
    width: 25%;
  }
}

@media (max-width: 1024px) and (min-width: 768px) {
  .elementor-1318 .elementor-element.elementor-element-509625b {
    width: 10%;
  }

  .elementor-1318 .elementor-element.elementor-element-998927e {
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/DomainName.vue